import React from "react";
import { Props } from "./types";

function CheckMark(props: Props) {
  return !props.isChecked ? (
    <svg className={props.className} viewBox="10 10 15 15">
      <g transform="translate(-37.927)">
        <path
          d="M111.887,147.23a1.637,1.637,0,0,0-2.292-.082l-5.238,4.992-2.21-2.292a1.637,1.637,0,0,0-2.292-.082,1.718,1.718,0,0,0,0,2.373l3.355,3.437a1.473,1.473,0,0,0,1.146.491,1.636,1.636,0,0,0,1.146-.491l6.384-6.056a2.489,2.489,0,0,0,.531-1.236A1.675,1.675,0,0,0,111.887,147.23Z"
          transform="translate(-50.473 -133.321)"
          fill="#fff"
        />
      </g>
    </svg>
  ) : (
    <svg className={props.className} viewBox="10 10 15 15">
      <g transform="translate(-37.927)">
        <path
          d="M111.887,147.23a1.637,1.637,0,0,0-2.292-.082l-5.238,4.992-2.21-2.292a1.637,1.637,0,0,0-2.292-.082,1.718,1.718,0,0,0,0,2.373l3.355,3.437a1.473,1.473,0,0,0,1.146.491,1.636,1.636,0,0,0,1.146-.491l6.384-6.056a2.489,2.489,0,0,0,.531-1.236A1.675,1.675,0,0,0,111.887,147.23Z"
          transform="translate(-50.473 -133.321)"
          fill="#fff"
        />
      </g>
    </svg>
  );
}

export { CheckMark };
